import styled, { css } from "styled-components";
import BasePage from "ui/common/components/layout/BasePage/BasePage";

export const GiftCardLoaderRoot = styled(BasePage)(
    ({ theme }) => css`
        padding: var(--base-page-padding);
        display: flex;
        flex-direction: column;
        row-gap: ${theme.spacing["1"]};
    `
)

export const GiftCardLoaderContainer = styled.div(
    () => css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    `
)